<template>
  <div>
    <section-header heading="2" ja="GIMMIでプリクラON会員証を使うには？"/>
    <div class="textArea">
      <p>プリクラ機の受付画面下に、黒いQRコードリーダーがあります。</p>
      <p>ここに、プリクラON会員証をかざして認証完了すれば、専用サービスがご利用になれます。<br>
        プリクラON会員証をかざすタイミングは、受付で「タッチしてはじめてね」を押下後、「会員認証をする？」画面で「する」を押下した後に表示される「プリクラON会員証をかざしてね」画面です。</p>
      <p>※QRコードは(株)デンソーウェーブの登録商標です。</p>
    </div>

    <section-header heading="2" ja="プリクラON会員証が認証されない"/>
    <div class="textArea">
      <p>以下の場合、プリクラON会員証が使用できないことがあります。</p>
      <p>
        ■プレイ店舗のネットワーク環境が不安定である<br>
        プレイ時の店舗のネットワーク環境によっては、「プリクラON」のサービスがご利用できない状態になっている可能性があります。<br>
        ネットワークの通信状態が悪い場合は、プリクラ機の受付にて専用のメッセージが表示されますので、そちらをご確認ください。
      </p>
      <p>
        ■すでに同じ会員証でプレイを開始している<br>
        プリクラON会員証は、認証してプレイを開始するとロックがかかり、同じ(または他の)プリクラ機で使用できなくなります。<br>
        正常にプレイを終了すると、ロックが外れて再び使用できるようになります。
      </p>
    </div>

    <section-header heading="2" ja="GIMMIでクーポンを使うには？" id="howtouse"/>
    <div class="textArea">
      <p>■使い方</p>
      <p>①プリクラONのクーポン画面からクーポンを持っていることを確認してください。</p>
      <div class="imgArea"><img src="@/assets/Png/Help/coupon_tutorial_gimmi01.png"></div>
      <p>
        ②GIMMIを利用する時に、<span class="boldText">コインを入れる前に会員証をかざしてください。</span><br>
        ※1人目にかざした人のクーポンが使えます。
      </p>
      <div class="imgArea"><img src="@/assets/Png/Help/coupon_tutorial_gimmi02.png"></div>
      <p>③使用するクーポンにタッチして選択してください。</p>
      <div class="imgArea"><img src="@/assets/Png/Help/coupon_tutorial_gimmi03.png"></div>
      <p>④使用する場合、「OK」ボタンを押すと、ご利用いただけます。</p>
      <div class="imgArea"><img src="@/assets/Png/Help/coupon_tutorial_gimmi04.png"></div>
    </div>

    <section-header heading="2" ja="入れたコインは返金してもらえる？"/>
    <div class="textArea">
      <p><span class="boldText">投入されたコインは、再排出されません。返金不可となりますのでご注意ください。</span></p>
    </div>
    <sub-btn @click="onBack()">戻る</sub-btn>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'

export default {
  name: "AppaboutGimmi03",
  components: {
    SectionHeader,
    SubBtn
  },
  methods: {
    onBack() { this.$router.push('/AppaboutGimmi') }
  }
}
</script>

<style lang="scss" scoped>
.textArea {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p {
    margin-top: 1em;
    .boldText {
      font-weight: bold;
    }
  }
}
.imgArea {
  margin-top: 20px;
  text-align: center;
  img { width: 70%; }
}
</style>
